import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { ISetting } from '../../../interfaces/simulation-settings';
import { useClient } from '../../client-api';
import { type SettingsUpdateDto, updateExternalItemSettings, type UpdateSettingsResponseDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUpdateProjectionExternalAssetItemSetting = (): UseMutationResult<UpdateSettingsResponseDto, AxiosError, SettingsUpdateDto> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (payload) => updateExternalItemSettings({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        onSuccess: (data: ISetting, variables) => {
            queryClient.setQueryData(queryKeys.saeExternalAssetItemSettings({ id: variables.id }), data);
            queryClient.invalidateQueries({ queryKey: queryKeys.saeExternalAssetSettings(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.projection(client?.partnerUuid) });
        },
    });
};
